import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { ROLES_ADMIN } from '@constants/roles';
import { ROUTES_ADMIN } from '@constants/routes';
import { FeatureFlagStatus } from '@enums/logistic.enum';
import { StorageKeys } from '@enums/storage.enum';
import { FeatureFlagsService } from '@providers/feature-flags/feature-flags.service';
import { RedirectService } from '@providers/redirect/redirect.service';
import { RolesManagmentService } from '@providers/roles-managment/roles-managment.service';
import { StorageService } from '@providers/storage/storage.service';
import { UserManagerService } from '@providers/user-manager/user-manager.service';
import { LoginService } from 'src/endpoints/login.service';

@Injectable()
export class AuthGuardRolesService implements CanActivate {

  constructor(
    private featureFlagService: FeatureFlagsService,
    private redirect: RedirectService,
    private loginService: LoginService,
    private rolesService: RolesManagmentService,
    private storage: StorageService,
    private userService: UserManagerService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const { role } = route.data;
    try{
      const isLogged = await this.isAuthenticated(role);
      return isLogged;
    } catch(error) {
      this.loginService.logoutMethod();
      return false;
    }
  }

  async isAuthenticated(moduleName: string): Promise<boolean> {
    try {
      if (!this.userService.currentUser) {
        const currentUser = await this.storage.getMyData(StorageKeys.COOKIE_NAME);
        this.userService.currentUser = currentUser;
      }

      const hasAccess: boolean = this.userService.currentUser?.privileges.some(module => (module.name === moduleName));
      if (!hasAccess || !await this.hasAccessPage(moduleName)) {
        this.redirect.redirectToInit();
        return false;
      }
      
      if (moduleName === ROLES_ADMIN.LOGISTIC) {
        const modulePresent = await this.featureFlagService.isFeatureFlagPresent('logistic');
        if (modulePresent === FeatureFlagStatus.failed) {
          this.redirect.redirectToInit();
          return false;
        }
      }

      if (moduleName === ROLES_ADMIN.STADISTIC) {
        const statsPresent = await this.featureFlagService.isFeatureFlagPresent('statistics');
        if (statsPresent === FeatureFlagStatus.failed) {
          this.redirect.redirectToInit();
          return false;
        }
      }

      return true;
    }
    catch (err) {
      this.loginService.logoutMethod();
      return false;
    }
  }

  async hasAccessPage(moduleName: string): Promise<boolean> {
    if (moduleName === ROLES_ADMIN.TICKETS && window.location.pathname === ROUTES_ADMIN.TICKETS_SUB_ROUTE.TICKETS_REFUNDS) {
      const modulePresent = await this.featureFlagService.isFeatureFlagPresent('manual-refunds');
      return modulePresent === FeatureFlagStatus.success;
    }
    if (moduleName === ROLES_ADMIN.ROLES && this.rolesService.onlyListRole && window.location.pathname === ROUTES_ADMIN.ROLES_SUB_ROUTE.ROLES_LIST_ROLES) {
      return false;
    }

    return true;
  }
}
